
export default {
     getPosts(){
      return fetch("https://bonjourinstagram.azurewebsites.net/api/HttpTrigger1?code=xALtCoXRP1so6xnLiULajGLDTpQ/D4l506CJZ1cCNseX7QLw1pZ5eQ==")//"https://www.instagram.com/@bonjourbrigadeiro/media")  //"https://api.instagram.com/v1/users/3012814037/media/recent?access_token=3012814037.5538495.79bde86b442b43ec82fa391fe223bc98&callback=?")
        .then(response => response.json()).then(response => {
            console.log('getting insta data');
            console.log(response);

            return response.data.filter(element => element.media_type == "IMAGE");
        })
    }
}